/* eslint-disable @typescript-eslint/default-param-last */
import { combineReducers } from 'redux';

import * as types from './types';

export const initState = {};

initState.version = '';
export const version = (state = initState.version, { type, payload }) => {
  switch (type) {
    case types.FETCH_INSTALLER_INFO.SUCCESS:
      return payload.version;
    case types.FETCH_INSTALLER_INFO.ERROR:
      return initState.version;
    default:
      return state;
  }
};

initState.installedMS = [];
export const installedMS = (
  state = initState.installedMS,
  { type, payload },
) => {
  switch (type) {
    case types.FETCH_INSTALLER_INFO.SUCCESS:
      return payload.integrations ?? initState.installedMS;
    case types.SET_MS_LOCAL_ENDPOINT:
      return state.map((ms) =>
        ms.name === payload.entity ? { ...ms, endpoint: payload.endpoint } : ms,
      );
    case types.INSTALLER_START_MS.SUCCESS:
    case types.INSTALLER_STOP_MS.SUCCESS:
      return state.map((ms) =>
        ms.name === payload.entity ? { ...ms, status: payload.status } : ms,
      );
    case types.INSTALLER_UPDATE_MS_VERSION.SUCCESS:
      return state.map((ms) =>
        ms.name === payload.entity ? { ...ms, version: payload.version } : ms,
      );
    case types.INSTALLER_REMOVE_MS.SUCCESS:
      return state.filter((ms) => !(ms.name === payload.entity));
    case types.FETCH_INSTALLER_INFO.ERROR:
      return initState.installedMS;
    default:
      return state;
  }
};

initState.availableMS = {};
export const availableMS = (
  state = initState.availableMS,
  { type, payload },
) => {
  switch (type) {
    case types.FETCH_AVAILABLE_MS.SUCCESS:
      return Object.fromEntries(payload.map((entity) => [entity, { entity }]));
    case types.FETCH_MS_VERSIONS.SUCCESS:
      return { ...state, [payload.entity]: payload };
    default:
      return state;
  }
};

initState.loading = false;
export const loading = (state = initState.loading, { type }) => {
  switch (type) {
    case types.INSTALLER_LOADER.START:
      return true;
    case types.INSTALLER_LOADER.STOP:
      return false;
    default:
      return state;
  }
};

export const isProduction = (state = true, action) => {
  switch (action.type) {
    case types.SET_IS_PRODUCTION:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  version,
  installedMS,
  availableMS,
  loading,
  isProduction,
});
